// Safe Notification Utility for Mobile Compatibility
// Bu dosya Notification API'sini güvenli bir şekilde kullanır

interface NotificationOptions {
    icon?: string;
    badge?: string;
    body?: string;
    tag?: string;
    [key: string]: unknown;
}

interface NotificationSupport {
    hasNotification: boolean;
    hasServiceWorker: boolean;
    hasPushManager: boolean;
    permission: NotificationPermission | 'unsupported';
}

/**
 * Güvenli bildirim gönderme fonksiyonu
 */
export const sendSafeNotification = (title: string, options: NotificationOptions = {}): boolean => {
    // Notification API'sinin varlığını kontrol et
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return false;
    }

    // İzin durumunu kontrol et
    if (Notification.permission === 'granted') {
        try {
            new Notification(title, {
                icon: '/logo192.png',
                badge: '/favicon.ico',
                ...options
            });
            return true;
        } catch (error) {
            return false;
        }
    } else if (Notification.permission !== 'denied') {
        // İzin iste
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                try {
                    new Notification(title, {
                        icon: '/logo192.png',
                        badge: '/favicon.ico',
                        ...options
                    });
                } catch (error) {
                }
            }
        });
        return false;
    } else {
        return false;
    }
};

/**
 * Bildirim izni kontrol et
 */
export const checkNotificationPermission = (): NotificationPermission | 'unsupported' => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'unsupported';
    }
    return Notification.permission;
};

/**
 * Bildirim izni iste
 */
export const requestNotificationPermission = async (): Promise<NotificationPermission | 'unsupported'> => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'unsupported';
    }
    
    try {
        const permission = await Notification.requestPermission();
        return permission;
    } catch (error) {
        return 'denied';
    }
};

/**
 * Service Worker ile bildirim gönder
 */
export const sendServiceWorkerNotification = async (title: string, options: NotificationOptions = {}): Promise<boolean> => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
        return false;
    }

    try {
        const registration = await navigator.serviceWorker.ready;
        await registration.showNotification(title, {
            icon: '/logo192.png',
            badge: '/favicon.ico',
            ...options
        });
        return true;
    } catch (error) {
        return false;
    }
};

/**
 * Toast bildirimi (mobil uyumlu alternatif)
 */
export const showToast = (
    message: string, 
    type: 'success' | 'error' | 'info' = 'info', 
    setSuccess?: (value: string) => void, 
    setError?: (value: string) => void
): void => {
    if (type === 'success' && setSuccess) {
        setSuccess(message);
        setTimeout(() => setSuccess(''), 3000);
    } else if (type === 'error' && setError) {
        setError(message);
        setTimeout(() => setError(''), 3000);
    } else {
    }
};

/**
 * Bildirim desteği kontrol et
 */
export const getNotificationSupport = (): NotificationSupport => {
    return {
        hasNotification: typeof window !== 'undefined' && 'Notification' in window,
        hasServiceWorker: typeof window !== 'undefined' && 'serviceWorker' in navigator,
        hasPushManager: typeof window !== 'undefined' && 'PushManager' in window,
        permission: typeof window !== 'undefined' && 'Notification' in window ? Notification.permission : 'unsupported'
    };
};

